require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.entries.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var plugin = require('tailwindcss/plugin');
var baseStyles = {
  position: 'relative',
  paddingBottom: "calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%)"
};
var childStyles = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0'
};
var noneComponent = {
  '.aspect-none': {
    position: 'static',
    paddingBottom: '0'
  },
  '.aspect-none > *': {
    position: 'static',
    height: 'auto',
    width: 'auto',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }
};
var aspectRatio = plugin(function (_ref) {
  var _ref6;
  var addComponents = _ref.addComponents,
    matchComponents = _ref.matchComponents,
    theme = _ref.theme,
    variants = _ref.variants,
    e = _ref.e;
  var values = theme('aspectRatio');
  if (matchComponents) {
    matchComponents({
      'aspect-w': function aspectW(value) {
        return [_objectSpread(_objectSpread({}, baseStyles), {}, {
          '--tw-aspect-w': value
        }), {
          '> *': childStyles
        }];
      },
      'aspect-h': function aspectH(value) {
        return {
          '--tw-aspect-h': value
        };
      }
    }, {
      values: values
    });
    addComponents(noneComponent);
    return;
  }
  var baseSelectors = Object.entries(values).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return ".".concat(e("aspect-w-".concat(key)));
  }).join(',\n');
  var childSelectors = Object.entries(values).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return ".".concat(e("aspect-w-".concat(key)), " > *");
  }).join(',\n');
  addComponents([(_ref6 = {}, _defineProperty(_ref6, baseSelectors, baseStyles), _defineProperty(_ref6, childSelectors, childStyles), _ref6), noneComponent, Object.entries(values).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];
    return _defineProperty({}, ".".concat(e("aspect-w-".concat(key))), {
      '--tw-aspect-w': value
    });
  }), Object.entries(values).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      key = _ref11[0],
      value = _ref11[1];
    return _defineProperty({}, ".".concat(e("aspect-h-".concat(key))), {
      '--tw-aspect-h': value
    });
  })], variants('aspectRatio'));
}, {
  theme: {
    aspectRatio: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12',
      13: '13',
      14: '14',
      15: '15',
      16: '16'
    }
  },
  variants: {
    aspectRatio: ['responsive']
  }
});
module.exports = aspectRatio;